<template>
  <div class="blank-list">
    <div v-for="(_, index) in value" :key="index" class="blank-row">
      <label>第 {{ index + 1 }} 空</label>
      <input :value="value[index]" type="text" placeholder="请输入答案" :disabled="disabled" @input="update(index, $event.target.value)">
    </div>
  </div>
</template>
<script>
export default { name: 'FillBlankQuestionInput', props: { value: { type: Array, default: () => [] }, disabled: { type: Boolean, default: false } }, methods: { update(index, content) { const next = [...this.value]; next[index] = content; this.$emit('input', next) } } }
</script>
<style scoped lang="scss">
@import '@/styles/tokens';
.blank-list { display: grid; gap: 12px; }
.blank-row { display: grid; grid-template-columns: 110px minmax(0, 1fr); gap: 12px; align-items: center; }
label { color: $color-text-secondary; font-size: 14px; font-weight: 700; }
@media (max-width: 768px) { .blank-row { grid-template-columns: 1fr; } }
</style>
